import { render, staticRenderFns } from "./変換枚数.vue?vue&type=template&id=14220c82&"
import script from "./変換枚数.ts?vue&type=script&lang=ts&"
export * from "./変換枚数.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports